//DB: cherry pick Clerk IO to Live
// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
( function () {
    'use strict';
    var jHtml = jQuery( 'html' );
    jQuery.extend( true, e4.settings, {
        search: {
            result: {
                pages: {
                    url: jHtml.data( 'area' ) + '/system/data/pages?q='
                },
                products: {
                    url: jHtml.data( 'area' ) + '/system/data/instant-search-clerk-io?q=',
                    showAllLink: jHtml.data( 'area' ) + '/shop/search?q=',
                    max: {
                        xs: 2,
                        sm: 2,
                        md: 3,
                        lg: 3,
                        xl: 3
                    }
                }
            }
        },
        ecom: {
            favoritelists: {
                url: jHtml.data( 'area' ) + '/system/data/favorites'
            },
            filters: {
                url: jHtml.data( 'area' ) + '/system/data/products-with-filters'
            },
            productlist: {
                url: jHtml.data( 'area' ) + '/system/data/products'
            },
            cart: {
                url: jHtml.data( 'area' ) + '/system/data/cart'
            },
            quickorder: {
                url: jHtml.data( 'area' ) + '/system/data/quickorder'
            },
            checkout: {
                url: jHtml.data( 'area' ) + '/system/data/checkout',
                termsAndConditions: jHtml.data( 'area' ) + '/terms-and-conditions'
            },
            myorders: {
                url: jHtml.data( 'area' ) + '/system/data/orders',
                pdf: {
                    url: jHtml.data( 'area' ) + '/system/data/orderpdf'
                }
            },
            product: {
                url: jHtml.data('area') + '/system/data/product'
            }
        },
        dealersearch: {
            map: {
                styles: [
                    {
                        'featureType': 'administrative',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'saturation': '-100'
                            }
                        ]
                    },
                    {
                        'featureType': 'administrative.province',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'off'
                            }
                        ]
                    },
                    {
                        'featureType': 'landscape',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'saturation': -100
                            },
                            {
                                'lightness': 65
                            },
                            {
                                'visibility': 'on'
                            }
                        ]
                    },
                    {
                        'featureType': 'poi',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'saturation': -100
                            },
                            {
                                'lightness': '50'
                            },
                            {
                                'visibility': 'simplified'
                            }
                        ]
                    },
                    {
                        'featureType': 'road',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'saturation': '-100'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.highway',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'visibility': 'simplified'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.arterial',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'lightness': '30'
                            }
                        ]
                    },
                    {
                        'featureType': 'road.local',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'lightness': '40'
                            }
                        ]
                    },
                    {
                        'featureType': 'transit',
                        'elementType': 'all',
                        'stylers': [
                            {
                                'saturation': -100
                            },
                            {
                                'visibility': 'simplified'
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'geometry',
                        'stylers': [
                            {
                                'hue': '#ffff00'
                            },
                            {
                                'lightness': -25
                            },
                            {
                                'saturation': -97
                            }
                        ]
                    },
                    {
                        'featureType': 'water',
                        'elementType': 'labels',
                        'stylers': [
                            {
                                'lightness': -25
                            },
                            {
                                'saturation': -100
                            }
                        ]
                    }
                ]
            },
            url: jHtml.data( 'area' ) + '/system/data/dealersearch',
            marker: {
                iconUrl: '/files/templates/designs/bloomingville/_assets/img/googlemaps/',
                iconFileNameDefault: 'marker-black.png',
                iconFileName: {
                    Partner: 'marker-partner.png',
                    Silver: 'marker-silver.png',
                    Gold: 'marker-gold.png',
                    Upcomer: 'marker-upcomer.png'
                }
            },
            clusterer: {
                imagePath: '/files/templates/designs/bloomingville/_assets/img/googlemaps/',
                imageExtension: 'png'
            }
        }
    } );
}() );
